import ActionModel from 'cio/models/action';
import CampaignModel from 'cio/models/campaign';
import isDestroyed from 'cio/utils/is-destroyed';

export default function isMultiLangBranchChild(action: ActionModel): boolean {
  // isDestroyed check needed for some environment switching scenarios, when
  // action is already unloaded from the store: http://localhost:4200/tests?testId=a1965823
  if (action == null || isDestroyed(action)) {
    return false;
  }

  if (!action.isMessagingType) {
    return false;
  }

  let campaignModel = action.belongsTo('campaign').value();
  if (campaignModel == null) {
    return false;
  }

  let parentBranchId = (campaignModel as CampaignModel).getConsolidatedActionParentBranchActionId(action.id);

  return parentBranchId != null;
}
